module.exports = __webpack_public_path__ + "static/ai-decisioning-mobile-590773b7c069967ae2cdc70fd6acbb36.svg";